module.exports = __webpack_public_path__ + "static/media/BB.d58cd559.webp";